import * as React from 'react';
import { useSelector } from 'react-redux';

import { LocationModalContainerDesktop } from './desktop';
import { selectIsRedesign } from '../../../selectors/isRedesign';

export const LocationModalContainer: React.FC = () => {
  const isRedesign = useSelector(selectIsRedesign);

  if (!isRedesign) {
    return null;
  }

  return <LocationModalContainerDesktop />;
};
